import React, { useEffect, useId, useRef, useState } from 'react';
import { HiPlusSm } from 'react-icons/hi';

function fileIdentityKey(file, index) {
	return `${file.name}::${file.size}::${file.lastModified}::${index}`;
}

const FileUploadComponent = React.forwardRef(({ label, name, setValue }, ref) => {
	const [selectedFiles, setSelectedFiles] = useState([]);
	const generatedId = useId();
	const inputId = name || generatedId;
	const inputRef = useRef(null);

	useEffect(() => {
		setValue(name, selectedFiles, { shouldValidate: true });
	}, [selectedFiles, name, setValue]);

	const setInputRef = (node) => {
		inputRef.current = node;
		if (typeof ref === 'function') {
			ref(node);
		} else if (ref) {
			ref.current = node;
		}
	};

	const handleFileChange = (e) => {
		const files = Array.from(e.target.files || []);
		if (files.length) {
			setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
		}
		e.target.value = '';
	};

	const handleRemoveFile = (index) => {
		setSelectedFiles((prevFiles) =>
			prevFiles.filter((_, fileIndex) => fileIndex !== index)
		);
	};

	return (
		<div className='file-upload-container'>
			<div className='file-upload-container__content'>
				<input
					type='file'
					name={name}
					id={inputId}
					onChange={handleFileChange}
					multiple
					className='file-upload-input'
					ref={setInputRef}
				/>
				<label htmlFor={inputId} className='file-upload-custom'>
					<span className='file-upload-label-text'>{label}</span>
					<HiPlusSm size='38' aria-hidden='true' />
				</label>
			</div>
			<ul className='selected-files-list'>
				{selectedFiles.map((file, index) => (
					<li
						key={fileIdentityKey(file, index)}
						className='file-item'
					>
						<span className='file-name'>{file.name}</span>
						<button
							type='button'
							className='remove-file-button'
							onClick={() => handleRemoveFile(index)}
						>
							Ta bort
						</button>
					</li>
				))}
			</ul>
		</div>
	);
});

FileUploadComponent.displayName = 'FileUploadComponent';

export default FileUploadComponent;
